import * as api from "./client";

// ============================================================================
// Types
// ============================================================================

export type TermsVersion = {
  id: string;
  documentKey: string;
  version: number;
  content: string;
  publishedAt: string;
  publishedBy: string | null;
  /** Counts up on every correction. The version number stays where it was. */
  revision: number;
  updatedAt: string;
  updatedBy: string | null;
};

/** A row of the version history. The list does not carry the text. */
export type TermsVersionSummary = Omit<TermsVersion, "content"> & {
  /** How many firm users have accepted this version. */
  acceptanceCount: number;
};

export type StaffTermsResponse = {
  /** Null before the terms have ever been published. */
  current: TermsVersion | null;
  versions: TermsVersionSummary[];
  requestId?: string | null;
};

export type TermsVersionResponse = {
  termsVersion: TermsVersion;
  requestId?: string | null;
};

export type CorrectTermsInput = {
  content: string;
  /** The revision the editor loaded. A correction is refused when the stored row moved on. */
  expectedRevision: number;
};

// ============================================================================
// Service
// ============================================================================

export const marketingTerms = {
  get: async (): Promise<StaffTermsResponse> => {
    return api.get<StaffTermsResponse>("/v1/terms");
  },

  /** Fixes the published text in place: no new version, nobody accepts again. */
  correct: async (input: CorrectTermsInput): Promise<TermsVersionResponse> => {
    return api.put<TermsVersionResponse>("/v1/terms", input);
  },

  /** Creates the next version, which every firm user must accept again. */
  publish: async (content: string): Promise<TermsVersionResponse> => {
    return api.post<TermsVersionResponse>("/v1/terms/publish", { content });
  },
};
